// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--1AJnu";
export var backgroundMedia = "hero-module--backgroundMedia--jBhfe";
export var primaryHeadline = "hero-module--primaryHeadline--2c4gZ";
export var secondaryHeadline = "hero-module--secondaryHeadline--3N2kV";